import { z } from 'zod';

export const NonEmptyStringSchema = z.string().trim().min(1);

export const HttpUrlSchema = z
  .url()
  .refine((value) => /^https?:\/\//i.test(value), 'Expected a public HTTP or HTTPS URL.');

export const QidSchema = z.string().regex(/^Q[1-9]\d*$/, 'Expected a Wikidata item QID.');

export const PropertyIdSchema = z.string().regex(/^P[1-9]\d*$/, 'Expected a Wikidata property ID.');

export const StatementIdSchema = z
  .string()
  .min(3)
  .refine(
    (value) => /^[Qq][1-9]\d*[$-][A-Za-z0-9-]+$/.test(value),
    'Expected a Wikidata statement identifier.',
  );

export const Sha256Schema = z.string().regex(/^[a-f0-9]{64}$/, 'Expected a SHA-256 digest.');

export const IsoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a calendar date in YYYY-MM-DD form.');

export const IsoDateTimeSchema = z
  .string()
  .regex(
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/,
    'Expected a UTC ISO-8601 timestamp.',
  );

export const LensIdSchema = z.enum([
  'personal',
  'family',
  'professional',
  'mentorship',
  'public-service',
  'creative',
  'organization',
]);

export type LensId = z.infer<typeof LensIdSchema>;

export const CoreLensIdSchema = z.enum(['personal', 'family']);

export type CoreLensId = z.infer<typeof CoreLensIdSchema>;

export const LivingStatusSchema = z.enum(['living', 'deceased', 'unknown']);

export type LivingStatus = z.infer<typeof LivingStatusSchema>;

export const AgeStatusSchema = z.enum(['minor', 'adult', 'unknown']);

export type AgeStatus = z.infer<typeof AgeStatusSchema>;

export const StatementRankSchema = z.enum(['preferred', 'normal', 'deprecated']);

export type StatementRank = z.infer<typeof StatementRankSchema>;
